const ShipmentStatusEnum = {
  PENDING: 1,
  DELIVERED: 2,
  CANCELED: 3,
  PARTIALLY_ATTENDED: 4,
  WAITING_FOR_INVOICE: 5,
};

const ShipmentStatusEnumById = {
  [ShipmentStatusEnum.PENDING]: "PENDENTE",
  [ShipmentStatusEnum.DELIVERED]: "ENTREGUE",
  [ShipmentStatusEnum.CANCELED]: "CANCELADO",
  [ShipmentStatusEnum.PARTIALLY_ATTENDED]: "PARCIALMENTE ATENDIDO",
  [ShipmentStatusEnum.WAITING_FOR_INVOICE]: "Aguardando Nota Fiscal",
};

export { ShipmentStatusEnum, ShipmentStatusEnumById };
